import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import ReactSpeedometer from "react-d3-speedometer";
import { useNetwork } from "wagmi";
import { Context } from "../context/context";
import { BUY_TAX, DEX_CHART_FRAME, SELL_TAX } from "../hooks/constant";
import { formatPrice } from "../hooks/contractHelper";
import { useTokenInfoStats } from "../hooks/useTokenInfo";
import work1Img from "../images/work.png";

/* global ApexCharts,Swiper */

export default function Dashboard() {
  const { chain } = useNetwork();
  const [updater] = useState(1);
  const tokenStats = useTokenInfoStats(updater);
  const [daysLaunch, setDaysLaunch] = useState(0);
  const count = useRef(0);
  const fearc = useRef(0);
  const { setProgress } = useContext(Context);
  const [fear, setFear] = useState(0);

  useEffect(() => {
    async function fetch() {
      const response = await axios.get(
        "https://api.coin-stats.com/v2/fear-greed"
      );
      if (response && response.data && response.data.now) {
        setFear(parseInt(response.data.now.value) * 10);
      }
    }

    if (fearc.current === 0) {
      fearc.current = 1;
      fetch();
      setProgress(100);
    }
  }, []);

  let buytax = () => {
    try {
      var options = {
        series: [BUY_TAX],
        chart: {
          width: 180,
          height: 180,
          type: "radialBar",
        },
        colors: ["#1EBA62"],
        plotOptions: {
          radialBar: {
            startAngle: -180,
            endAngle: 120,
            hollow: {
              size: "60%",
              background: "rgba(1, 163, 255, 0.8)",
              margin: 15,
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: 20,
                show: true,
                color: "#888",
                fontSize: "12px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -10,
                color: "#1EBA62",
                fontWeight: 700,
                fontSize: "18px",
                show: true,
              },
            },
            track: {
              background: "#737b8b",
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: [""],
        responsive: [
          {
            breakpoint: 575,
            options: {
              chart: {
                height: 200,
              },
            },
          },
        ],
      };
      var chart = new ApexCharts(document.querySelector("#buytax"), options);
      chart.render();
    } catch (err) {
      console.log(err.message);
    }
  };

  let selltax = () => {
    try {
      var options = {
        series: [SELL_TAX],
        chart: {
          width: 180,
          height: 180,
          type: "radialBar",
        },
        colors: ["#dc3545"],
        plotOptions: {
          radialBar: {
            startAngle: -180,
            endAngle: 120,
            hollow: {
              size: "60%",
              background: "rgba(255, 99, 71, 0.8)",
              margin: 15,
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: 20,
                show: true,
                color: "#888",
                fontSize: "12px",
              },
              value: {
                formatter: function (val) {
                  return val + "%";
                },
                offsetY: -10,
                color: "#dc3545",
                fontWeight: 700,
                fontSize: "18px",
                show: true,
              },
            },
            track: {
              background: "#737b8b",
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: [""],
        responsive: [
          {
            breakpoint: 575,
            options: {
              chart: {
                height: 200,
              },
            },
          },
        ],
      };
      var chart = new ApexCharts(document.querySelector("#selltax"), options);
      chart.render();
    } catch (err) {
      console.log(err.message);
    }
  };

  // useEffect(() => {
  //   var dateofvisit = moment("09-01-2025", "DD-MM-YYYY");
  //   var today = moment();
  //   setDaysLaunch(today.diff(dateofvisit, "days"));
  //   if (count.current === 0) {
  //     count.current = 1;

  //     buytax();
  //     selltax();
  //   }
  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    // Set days to 0 since token hasn't launched yet
    setDaysLaunch(0);
    if (count.current === 0) {
      count.current = 1;
      buytax();
      selltax();
    }
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="jumps-prevent " style={{ paddingTop: "63.998px" }}></div>
      <div className="main-content side-content default-height pt-0 bg-primary-gradient">
        <div className="main-container container-fluid">
          <div className="inner-body">
            <div className="page-header">
              <div>
                <h2 className="main-content-title tx-24 mg-b-5">
                  Welcome To Dashboard
                </h2>
              </div>
            </div>
            <div className="row row-sm">
              <div className="col-sm-12 col-lg-12 col-xl-8">
                <div className="row row-sm">
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="card custom-card bg-gradient-to-r">
                      <div className="card-body">
                        <div className="card-item">
                          <div className="card-item-icon card-icon">
                            <svg
                              className="text-primary"
                              xmlns="http://www.w3.org/2000/svg"
                              enableBackground="new 0 0 24 24"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                            >
                              <g>
                                <rect
                                  height="14"
                                  opacity=".3"
                                  width="14"
                                  x="5"
                                  y="5"
                                ></rect>
                                <g>
                                  <rect
                                    fill="none"
                                    height="24"
                                    width="24"
                                  ></rect>
                                  <g>
                                    <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z"></path>
                                    <rect
                                      height="5"
                                      width="2"
                                      x="7"
                                      y="12"
                                    ></rect>
                                    <rect
                                      height="10"
                                      width="2"
                                      x="15"
                                      y="7"
                                    ></rect>
                                    <rect
                                      height="3"
                                      width="2"
                                      x="11"
                                      y="14"
                                    ></rect>
                                    <rect
                                      height="2"
                                      width="2"
                                      x="11"
                                      y="10"
                                    ></rect>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="card-item-title mb-2">
                            <label className="main-content-label tx-13 font-weight-bold mb-1 text-white">
                              Circulating Supply
                            </label>
                          </div>
                          <div className="card-item-body">
                            <div className="card-item-stat">
                              <h5 className="font-weight-bold">
                                {tokenStats.totalSuppl
                                  ? formatPrice(tokenStats.totalSuppl)
                                  : 0}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="card custom-card bg-gradient-to-r">
                      <div className="card-body">
                        <div className="card-item">
                          <div className="card-item-icon card-icon">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                            >
                              <path d="M0 0h24v24H0V0z" fill="none"></path>
                              <path
                                d="M12 4c-4.41 0-8 3.59-8 8 0 1.82.62 3.49 1.64 4.83 1.43-1.74 4.9-2.33 6.36-2.33s4.93.59 6.36 2.33C19.38 15.49 20 13.82 20 12c0-4.41-3.59-8-8-8zm0 9c-1.94 0-3.5-1.56-3.5-3.5S10.06 6 12 6s3.5 1.56 3.5 3.5S13.94 13 12 13z"
                                opacity=".3"
                              ></path>
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.07 18.28c.43-.9 3.05-1.78 4.93-1.78s4.51.88 4.93 1.78C15.57 19.36 13.86 20 12 20s-3.57-.64-4.93-1.72zm11.29-1.45c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"></path>
                            </svg>
                          </div>
                          <div className="card-item-title mb-2">
                            <label className="main-content-label tx-13 font-weight-bold mb-1 text-white">
                              Market Cap
                            </label>
                          </div>
                          <div className="card-item-body">
                            <div className="card-item-stat">
                              <h5 className="font-weight-bold">
                                $
                                {tokenStats.totalSuppl
                                  ? formatPrice(
                                      tokenStats.totalSuppl *
                                        tokenStats.token_price
                                    )
                                  : 0}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="card custom-card bg-gradient-to-r">
                      <div className="card-body">
                        <div className="card-item">
                          <div className="card-item-icon card-icon">
                            <svg
                              className="text-primary"
                              xmlns="http://www.w3.org/2000/svg"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                            >
                              <path d="M0 0h24v24H0V0z" fill="none"></path>
                              <path
                                d="M12 4c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm1.23 13.33V19H10.9v-1.69c-1.5-.31-2.77-1.28-2.86-2.97h1.71c.09.92.72 1.64 2.32 1.64 1.71 0 2.1-.86 2.1-1.39 0-.73-.39-1.41-2.34-1.87-2.17-.53-3.66-1.42-3.66-3.21 0-1.51 1.22-2.48 2.72-2.81V5h2.34v1.71c1.63.39 2.44 1.63 2.49 2.97h-1.71c-.04-.97-.56-1.64-1.94-1.64-1.31 0-2.1.59-2.1 1.43 0 .73.57 1.22 2.34 1.67 1.77.46 3.66 1.22 3.66 3.42-.01 1.6-1.21 2.48-2.74 2.77z"
                                opacity=".3"
                              ></path>
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.31-8.86c-1.77-.45-2.34-.94-2.34-1.67 0-.84.79-1.43 2.1-1.43 1.38 0 1.9.66 1.94 1.64h1.71c-.05-1.34-.87-2.57-2.49-2.97V5H10.9v1.69c-1.51.32-2.72 1.3-2.72 2.81 0 1.79 1.49 2.69 3.66 3.21 1.95.46 2.34 1.15 2.34 1.87 0 .53-.39 1.39-2.1 1.39-1.6 0-2.23-.72-2.32-1.64H8.04c.1 1.7 1.36 2.66 2.86 2.97V19h2.34v-1.67c1.52-.29 2.72-1.16 2.73-2.77-.01-2.2-1.9-2.96-3.66-3.42z"></path>
                            </svg>
                          </div>
                          <div className="card-item-title  mb-2">
                            <label className="main-content-label tx-13 font-weight-bold mb-1 text-white">
                              Current Price(LockChain)
                            </label>
                          </div>
                          <div className="card-item-body">
                            <div className="card-item-stat">
                              <h5 className="font-weight-bold">
                                $
                                {tokenStats.token_price
                                  ? formatPrice(tokenStats.token_price)
                                  : 0}{" "}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="card custom-card bg-gradient-to-r">
                      <div className="card-body">
                        <div className="card-item">
                          <div className="card-item-icon card-icon">
                            <svg
                              className="text-primary"
                              xmlns="http://www.w3.org/2000/svg"
                              enableBackground="new 0 0 24 24"
                              height="24"
                              viewBox="0 0 24 24"
                              width="24"
                            >
                              <g>
                                <rect
                                  height="14"
                                  opacity=".3"
                                  width="14"
                                  x="5"
                                  y="5"
                                ></rect>
                                <g>
                                  <rect
                                    fill="none"
                                    height="24"
                                    width="24"
                                  ></rect>
                                  <g>
                                    <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M19,19H5V5h14V19z"></path>
                                    <rect
                                      height="5"
                                      width="2"
                                      x="7"
                                      y="12"
                                    ></rect>
                                    <rect
                                      height="10"
                                      width="2"
                                      x="15"
                                      y="7"
                                    ></rect>
                                    <rect
                                      height="3"
                                      width="2"
                                      x="11"
                                      y="14"
                                    ></rect>
                                    <rect
                                      height="2"
                                      width="2"
                                      x="11"
                                      y="10"
                                    ></rect>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                          <div className="card-item-title mb-2">
                            <label className="main-content-label tx-13 font-weight-bold mb-1 text-white">
                              Liquidity
                            </label>
                          </div>
                          <div className="card-item-body">
                            <div className="card-item-stat">
                              <h5 className="font-weight-bold">
                                $
                                {tokenStats.liquidity
                                  ? formatPrice(tokenStats.liquidity)
                                  : 0}{" "}
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row row-sm">
                  <div className="col-sm-12 col-lg-12 col-xl-12">
                    <iframe
                      className="dexscreen-card"
                      title="LockChain Chart"
                      style={{ height: "519px" }}
                      src={DEX_CHART_FRAME}
                    ></iframe>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-12 col-xl-4 ">
                <div className="card custom-card text-center text-primary pb-0 bg-gradient-to-r">
                  <div className="card-header border-0 pb-0 px-3 pt-0">
                    <div className="mt-2">
                      <h5 className="mb-0 text-white">
                        Crypto Fear and Greed Indicator
                      </h5>
                    </div>
                  </div>
                  <ReactSpeedometer
                    needleHeightRatio={0.7}
                    height={200}
                    value={fear}
                    customSegmentStops={[0, 250, 500, 750, 1000]}
                    segmentColors={["#f02836", "#f07d29", "#9aca82", "#35b348"]}
                    currentValueText={`Current: ${fear / 10} ${
                      fear <= 250
                        ? "Extreme Fear"
                        : fear <= 500
                        ? "Fear"
                        : fear <= 750
                        ? "Greed"
                        : "Extreme Greed"
                    }`}
                    customSegmentLabels={[
                      {
                        text: "Extreme Fear",
                        position: "OUTSIDE",
                        color: "#d8dee9",
                        fontSize: "12px",
                      },
                      {
                        text: "Fear",
                        position: "OUTSIDE",
                        color: "#d8dee9",
                        fontSize: "12px",
                      },
                      {
                        text: "Greed",
                        position: "OUTSIDE",
                        color: "#d8dee9",
                        fontSize: "12px",
                      },
                      {
                        text: "Extreme Greed",
                        position: "OUTSIDE",
                        color: "#d8dee9",
                        fontSize: "12px",
                      },
                    ]}
                    ringWidth={47}
                    needleTransitionDuration={3333}
                    needleTransition="easeElastic"
                    needleColor={"#a7ff83"}
                    textColor={"#ffffff"}
                    valueTextFontSize={"14px"}
                    labelFontSize={"12px"}
                  />
                </div>
                <div className="card custom-card bg-gradient-to-r">
                  <div className="card-body">
                    <div className="row row-sm">
                      <div className="col-6">
                        <div className="card-item-title">
                          <label className="main-content-label tx-13 font-weight-bold mb-2 text-white">
                            Project Launch
                          </label>
                          <span className="d-block tx-12 mb-0 text-muted">
                            $LOCKCHAIN Project launched on
                          </span>
                        </div>
                        <p className="mb-0 tx-24 mt-2">
                          <b className="text-white">
                            {daysLaunch ? daysLaunch : 0} days
                          </b>
                        </p>
                        <a href="#sec" className="text-muted">
                          09 Thursday , Jan 2025
                        </a>
                      </div>
                      <div className="col-6">
                        <img src={work1Img} alt="work" className="best-emp" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card custom-card overflow-hidden bg-gradient-to-r">
                  <div className="card Upgrade">
                    <div className="card-body d-flex align-items-center ps-0">
                      <div className="d-inline-block position-relative donut-chart-sale ">
                        <div id="buytax"></div>
                      </div>
                      <div
                        style={{
                          paddingLeft: "23px",
                        }}
                        className="upgread-stroage"
                      >
                        <h4 className="text-white">BUY TAX</h4>
                        <p className="text-white">
                          Buy taxes on trade from dex
                        </p>
                        <button
                          type="button"
                          className="btn btn-success btn-sm light"
                        >
                          {BUY_TAX}% of each DEX buy
                        </button>
                        <div className="color-picker mt-3">
                          <p className="mb-0  text-white">
                            <svg
                              className="me-2"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="14"
                                height="14"
                                rx="4"
                                fill="#008FFB"
                              />
                            </svg>
                            Vesting (37%)
                          </p>
                        </div>
                        <div className="color-picker">
                          <p className="mb-0 text-white">
                            <svg
                              className="me-2"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="14"
                                height="14"
                                rx="4"
                                fill="#00E396"
                              />
                            </svg>
                            Protocol fees + Marketing (3%)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card custom-card overflow-hidden bg-gradient-to-r">
                  <div className="card Upgrade">
                    <div className="card-body d-flex align-items-center ps-0">
                      <div className="d-inline-block position-relative donut-chart-sale ">
                        <div id="selltax"></div>
                      </div>
                      <div
                        style={{
                          paddingLeft: "23px",
                        }}
                        className="upgread-stroage"
                      >
                        <h4 className="text-white">Sell TAX</h4>
                        <p className="text-white">
                          Sell taxes on trade from dex
                        </p>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm light"
                        >
                          {SELL_TAX}% of each DEX sell
                        </button>
                        <div className="color-picker mt-3">
                          <p className="mb-0  text-white">
                            <svg
                              className="me-2"
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                width="14"
                                height="14"
                                rx="4"
                                fill="#008FFB"
                              />
                            </svg>
                            Protocol fees + Marketing (3%)
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
